import React, { useContext } from 'react';

import { PageLayout } from '../../../components/ui/PageLayout';
import { useContent } from '../../../hooks/useContent';
import { MlifeActivationContext } from '../MlifeActivationContext';

import { MlifeAccountSetupContextProvider } from './MlifeAccountSetupContext';
import { MlifeAccountSetupForm } from './MlifeAccountSetupForm';
import { StyledContent } from './styles';

export function MlifeAccountSetup() {
  const { activationRequest, setStep } = useContext(MlifeActivationContext);
  const { getContentByPath } = useContent();

  if (!activationRequest) {
    setStep('activate');
    return (
      <div data-testid='mlifeActivation-accountSetup-no-content'>
        Something has gone wrong, please refresh your page and try again
      </div>
    );
  }

  return (
    <StyledContent>
      <PageLayout
        testId='mlifeActivation-accountSetup'
        title={getContentByPath('mlifeActivation.accountSetupSection.title')}
        description={getContentByPath('mlifeActivation.accountSetupSection.description')}
      >
        <MlifeAccountSetupContextProvider activationRequest={activationRequest}>
          <MlifeAccountSetupForm />
        </MlifeAccountSetupContextProvider>
      </PageLayout>
    </StyledContent>
  );
}

MlifeAccountSetup.displayName = 'MlifeAccountSetup';
